var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgSpinnerArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1v1.8A5.2 5.2 0 1 1 2.8 8H1a7 7 0 1 0 7-7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21 9.29 7.48 7H6.15a1 1 0 1 1 0-2h3.77a1 1 0 0 1 1 1v3.74a1 1 0 1 1-2 0v-1.3l-2.27 2.27A1 1 0 0 1 5.24 9.3z",
    className: "arrow"
  })));
});